import {Control, Controller} from "react-hook-form";
import React, {useEffect, useState} from "react";

import {ControlledTextFieldFilled} from "./ControlledTextField";
import {Autocomplete, AutocompleteRenderOptionState, Chip, createFilterOptions, TextField} from "@mui/material";

// import HelperInputText from "./HelperInputText";
// import { removeDuplicatesById } from "../../utils";
import {EntityWithIdAndDescription, EntityWithIdAndDescriptionFields, EntityWithIdFields} from "src/types/baseEntities";
import {removeDuplicatesById} from "src/utils/helpers";
import {inputMinStyles} from "./styles";

interface FilterEntity extends EntityWithIdAndDescription {
  title: string
}

const filter = createFilterOptions<FilterEntity>();

interface ControlledAutocompleteProps /*extends AutocompleteProps<any, boolean, boolean, boolean>*/
{
  loadOptions: () => Promise<any[]> | undefined,
  control: Control<any>,
  name: string,
  label?: string | null,
  defaultValues?: any[];
  disabled?: boolean,
  multiple?: boolean,
  valueField?: string,
  optionField?: string
  onAddOption?: (value: string, prevValues: any[]) => void,
  required?: boolean,
  readOnly?: boolean

  disableClearable?: boolean,

  // TagComponent: (value: TOption) => ReactNode
  // TagComponent?: <TOption extends EntityWithIdAndDescription>(value: TOption) => ((props: any) => JSX.Element)

  TagComponent?: (value: any) => ((props: any) => JSX.Element)
  renderOption?: ((props: React.HTMLAttributes<HTMLLIElement>, option: any, state: AutocompleteRenderOptionState) => React.ReactNode),
  min?: boolean,
}

// TODO: ChipComponent prop que reciba la opción seleccionada, por ej, para meterle un
// logo o color que venga del TOption extends EntityWithIdAndDescription

type F = typeof ControlledAutocomplete

export const ControlledAutocomplete = (props: ControlledAutocompleteProps) => {

  //const theme = useTheme();

  //const classes = controlledTextFieldStyles(theme);

  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState<any[]>([])

  const {loadOptions} = props;

  useEffect(() => {
    const request = loadOptions();

    if (request) {
      setLoading(true);

      request.then(options => {
        setOptions(options);
        setLoading(false);
      }).catch(() => setLoading(false))
    } else
      setOptions([]);
  }, [loadOptions])

  return (
    <Controller
      control={props.control}
      name={props.name || ''}
      render={({field: {onChange, value, ...field}, fieldState: {error}}) => {
        if (props.disabled)
          return (
            <ControlledTextFieldFilled
              {...props}
              select
              options={options}
            />
          );
        if (loading)
          return (
            <ControlledTextFieldFilled
              {...props}
              select
              options={undefined}
            />
          );

        return (
          <Autocomplete
            {...field}

            limitTags={props?.min ? 2 : undefined}
            ListboxProps={props.min ? {
              style: {
                fontSize: '14px',
                lineHeight: '1.2',
                padding: '6px 8px',
              }
            } : {}}

            options={options}

            // Si no funciona bien el rendereo de las opciones seleccionadas, revisar como se settea el value
            value={
              !props?.multiple ?
                value
                : options.filter(option => {
                    if (!value) return false
                    if (props.valueField) return value.includes(option[props.valueField])
                    
return value.some((v: any) => (typeof v === 'object' ? v?.id === option.id : v === option.id))
                  })
            }

            defaultValue={props.defaultValues}
            onChange={(_, data) => {
              if (data)
                if (props.multiple) {
                  if (!!props.onAddOption) {
                    const newValue = data.filter((x: any) => !x.id);
                    if (newValue && newValue.length)
                      props.onAddOption && props.onAddOption(newValue[0][EntityWithIdAndDescriptionFields.Description], data);
                  }

                  const filtered_data = removeDuplicatesById(data)
                  onChange(props.valueField ? filtered_data.map((v: any) => v?.[props.valueField!]) : filtered_data)
                } else if (!data.id)
                  props.onAddOption && props.onAddOption(data[EntityWithIdAndDescriptionFields.Description], data);
                else
                  onChange(props.valueField ? props.multiple ? data.map((d: any) => d?.[props.valueField!]) : data?.[props.valueField] : data)
              else {
                onChange(undefined);
              }
            }}

            // onInputChange={(_, data) => {

            // }}
            filterOptions={(options, params) => {
              const filtered = filter(options, params);

              const {inputValue} = params;

              // Suggest the creation of a new value
              const isExisting = options.some((option) => inputValue === option.description);
              if (inputValue !== '' && !isExisting && !!props.onAddOption) {
                const input = {
                  [EntityWithIdFields.Id]: 0,
                  [EntityWithIdAndDescriptionFields.Description]: inputValue
                }
                filtered.push({
                  ...input,
                  title: `Adicione "${inputValue}"`,
                });
              }

              return filtered ?? [];
            }}
            multiple={props.multiple}
            disabled={props.readOnly}
            disableClearable={props.disableClearable}
            ChipProps={{color: 'primary'}}
            id={`id_${props.name}`}
            key={`autocomplete_id_${props.name}`}
            style={{width: '100%'}}
            getOptionLabel={(option) => props.optionField ? option[props.optionField] : (option.title ? option.title : option.descripcion)}

            // getOptionSelected={((option: any, value: any) => value.hasOwnProperty('id') ? (option.id === value?.id) : (option.id === value))}
            isOptionEqualToValue={(option: any, value: any) => value.hasOwnProperty('id') ? (option.id === value?.id) : (option.id === value)}
            renderTags={(value: any[], getTagProps) =>
              value.map((option: any, index: number) => {
                if (!props.TagComponent) {
                  return (
                    <Chip
                      color="primary"
                      label={props.optionField ? option[props.optionField] : option.descripcion}
                      sx={props.min ? {
                        height: '15px',
                        fontSize: '10px',
                        p: 0,
                        m: 0,
                        lineHeight: '1',
                      } : {}}
                      {...getTagProps({index})}
                      size='small'
                    />
                  )
                }

                const Component = props.TagComponent(option)

                return (
                  <Component  sx={props.min ? {
                    height: '15px',
                    fontSize: '10px',
                    p: 0,
                    m: 0,
                    lineHeight: '1',
                  } : {}} {...getTagProps({index})} />
                )

                // (
                //     // eslint-disable-next-line react/jsx-key
                //     props.TagComponent ?
                //         props.TagComponent(value) :
                // )
              })
            }
            renderInput={(params) => {
              if (props.multiple) {
                return (
                  <TextField {...params}
                             variant="outlined"
                             size="small"
                             error={!!error}
                             label={props.label}
                             required={props.required}

                    // className={classes.textFilled}
                             inputProps={{
                               ...params.inputProps,

                             }}
                             InputProps={props.min ? {
                               style: {
                                 fontSize: inputMinStyles.fontSize,
                                 lineHeight: inputMinStyles.fontSize,

                                 padding: '0 8px',
                                 minHeight: inputMinStyles.height,
                                 height: 'auto',
                                 display: 'flex',
                                 alignItems: 'center',
                                 flexWrap: 'wrap',
                               },
                               sx: {
                                 '& .MuiAutocomplete-endAdornment .MuiIconButton-root svg': {
                                   padding: '1px',
                                   fontSize: '24px',
                                 },
                               },
                               ...params.InputProps,
                             } : {
                               ...params.InputProps,
                             }}
                             InputLabelProps={props.min ? {
                               style: {
                                 fontSize: '14px',
                                 lineHeight: '1.2',
                               }
                             } : {}}
                             focused={!!params.inputProps.value}
                             helperText={error && error.message}
                  />

                );
              }

              const optionSelect = options.find(x => x.id === value);

              return (
                <TextField {...params}
                           variant="outlined"
                           size="small"
                           error={!!error}
                           label={props.label}
                           required={props.required}

                           inputProps={{
                             ...params.inputProps,
                             value: (value && optionSelect) ? // @ts-ignore
                               props.optionField ? optionSelect[props.optionField] : optionSelect.descripcion : params.inputProps.value,


                           }}

                           InputProps={{
                             style: {
                               fontSize: '12px',
                               lineHeight: '1.2',
                               padding: '6px 8px',
                               backgroundColor: 'red',
                             }
                           }}

                  // @ts-ignore
                           focused={!!params.inputProps.value}
                />

              )
            }}

            // renderOption={props.renderOption}

            renderOption={props.renderOption ? (optionProps, option, state) => {
              const customComponent = props.renderOption!(optionProps, option, state);
              if (React.isValidElement(customComponent)) {
                return React.cloneElement(customComponent, {
                  ...customComponent.props,
                  style: {
                    ...customComponent.props.style,
                    ...(props.min ? {
                      fontSize: '14px',
                      lineHeight: '1.2',
                      padding: '6px 8px',
                    } : {}),
                  },
                });
              }

              return customComponent;
            } : undefined}

          />
        )
      }}
    />
  )
}

